/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
// constants
import {
  NO_SUPERCHARGERS,
  IMPOSSIBLE,
  EASTER_EGG_ADDRESS,
  RED_PLANET,
  NO_SUPERCHARGER_FLAG,
  IMPOSSIBLE_TRIP,
  NOT_SINGLE_REGION,
  NOT_FOUND_DISTANCE,
  NOT_FOUND_UNICODE,
  DIVISION_BY_ZERO,
  BFR,
} from '../../../lib/Constants';

// actions
// eslint-disable-next-line import/no-cycle
import {
  deleteErrorMessages,
  createErrorMsgError,
} from '../../ErrorMsg/actions';
// eslint-disable-next-line import/no-cycle
import {
  updateSuperchargersCharging,
  updateSuperchargersRoutechargers,
  updateSuperchargersChargers,
} from '../../Superchargers/actions';

// helpers
import Client from '../../../lib/Client';
import MapUtils from '../../../lib/MapUtils';
import MapMarkers from '../../../lib/MapMarkers';
import AnalyticsUtils from '../../../lib/AnalyticsUtils';
import { makeActionCreator, saveTrip } from '../../../lib/Utils';

export const DIRECTIONS_FETCH_REQUEST = 'DIRECTIONS_FETCH_REQUEST';
const fetchDirectionsRequest = makeActionCreator(DIRECTIONS_FETCH_REQUEST);

export const DIRECTIONS_FETCH_SUCCESS = 'DIRECTIONS_FETCH_SUCCESS';
export const fetchDirectionsSuccess = makeActionCreator(
  DIRECTIONS_FETCH_SUCCESS,
  'directions',
);

export const DIRECTIONS_SHOW_ALTMAP = 'DIRECTIONS_SHOW_ALTMAP';
export const showDirectionsAltMap = makeActionCreator(
  DIRECTIONS_SHOW_ALTMAP,
  'showAltMap',
);

export const DIRECTIONS_UPDATE_POLYLINE = 'DIRECTIONS_UPDATE_POLYLINE';
export const updateDirectionsPolyline = makeActionCreator(
  DIRECTIONS_UPDATE_POLYLINE,
  'polyline',
);

export const DIRECTIONS_FETCH_FAILURE = 'DIRECTIONS_FETCH_FAILURE';
export const fetchDirectionsFailure = makeActionCreator(
  DIRECTIONS_FETCH_FAILURE,
);

export const DIRECTIONS_UPDATE_DISTANCE = 'DIRECTIONS_UPDATE_DISTANCE';
export const updateDirectionsDistance = makeActionCreator(
  DIRECTIONS_UPDATE_DISTANCE,
  'distance',
);

function handleDirectionsAnalytics({
  origin,
  chargerPlaces,
  chargers,
  destination,
  chargeTime,
  waypoints,
  model,
}) {
  AnalyticsUtils.pushRouteResponse({
    tripStart: JSON.stringify(origin[0].analytics),
    tripWaypoint: JSON.stringify(chargerPlaces.map(s => s.analytics)),
    tripChargeStop: JSON.stringify(chargers.map(c => c.name)),
    tripEnd: JSON.stringify(destination[0].analytics),
    tripChargeDuration: chargeTime,
    tripTotalDurationMiles: destination[0].distance,
    tripTotalDurationTime: destination[0].duration,
    tripNumberChargeStops: chargers.length,
    tripNumberWaypointStops: waypoints.length,
    tripCarModel: model,
  });
}

// eslint-disable-next-line object-curly-newline
function unlockEasterEgg({ dispatch, places, placesLen, params }) {
  AnalyticsUtils.pushInteraction({
    interaction: 'get_route',
    label: 'get_route',
  });

  dispatch(deleteErrorMessages());

  const origin = [
    {
      type: 'origin',
      address: places[0].address,
      analytics: places[0].analytics,
    },
  ];
  const stopovers = [];
  if (placesLen > 1) {
    let i = 1;
    for (i; i < placesLen; i += 1) {
      stopovers.push({
        type: 'stopover',
        address: places[i].address,
        analytics: places[i].analytics,
      });
    }
  }
  const destination = [
    {
      type: 'destination',
      address: places[placesLen].address,
      duration: 6912000,
      distance: 39000000,
      analytics: places[placesLen].analytics,
    },
  ];

  dispatch(updateDirectionsDistance(destination[0].distance));

  let directions = origin;

  directions = directions.concat(stopovers);
  directions = directions.concat(destination);

  handleDirectionsAnalytics({
    origin,
    chargerPlaces: stopovers,
    chargers: [],
    destination,
    chargeTime: 0,
    waypoints: stopovers,
    model: params.vehicle.model,
  });

  dispatch(fetchDirectionsSuccess(directions));

  dispatch(showDirectionsAltMap(true));
}

function constructDirectionParams({ model, places, placesLen }) {
  const sanatizedModel = model.replace(/^(\d_){1}/g, '');
  const params = {
    vehicle: {
      model: sanatizedModel,
    },
    route: {
      origin: `${places[0].lat},${places[0].lng}`,
      destination: `${places[placesLen].lat},${places[placesLen].lng}`,
    },
  };

  // add stopovers
  if (placesLen > 1) {
    params.route.stopovers = [];
    let i = 1;
    for (i; i < placesLen; i += 1) {
      params.route.stopovers.push(`${places[i].lat},${places[i].lng}`);
    }
  }

  return params;
}

function dispatchRouteChargers({ getState, chargers, dispatch }) {
  // delete supercharger network if a long distance trip
  const { superchargers } = getState().Superchargers;
  MapMarkers.deleteMapMarkers(superchargers);

  MapMarkers.updateRoutechargerMarkers(chargers);
  dispatch(updateSuperchargersRoutechargers(chargers));
  dispatch(updateSuperchargersCharging(true));
}

function constructDestination({ places, placesLen, res, chargeTime }) {
  return [
    {
      type: 'destination',
      address: places[placesLen].address,
      duration: res.body.total_drive_dur_s + chargeTime,
      distance: res.body.total_drive_mi,
      analytics: places[placesLen].analytics,
    },
  ];
}

// TODO: REFACTOR THIS
export function fetchDirections(places, vehicle) {
  return (dispatch, getState) => {
    dispatch(fetchDirectionsRequest());

    const { model, modelCode } = vehicle;
    const placesLen = places.length - 1;
    const params = constructDirectionParams({ model, places, placesLen });

    // for extra terrestrials
    const easterEggOrigin = places[placesLen - 1].address;
    const easterEggDestination = places[placesLen].address;
    if (
      easterEggOrigin === EASTER_EGG_ADDRESS &&
      easterEggDestination === RED_PLANET
    ) {
      unlockEasterEgg({ dispatch, places, placesLen, params });
    } else {
      // Analytics
      AnalyticsUtils.pushInteraction({
        interaction: 'get_route',
        label: 'get_route',
      });

      // save the trip in encoded string so user can share/return to their trip
      saveTrip({ vehicle: params.vehicle, places: getState().Places });

      // fetch directions
      Client.fetchDirections(params, (err, res) => {
        if (err) {
          AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });

          dispatch(fetchDirectionsFailure());

          const { somethingWrong } = getState().ErrorMsg.errors;
          if (err.status !== 404) dispatch(createErrorMsgError(somethingWrong));
        } else {
          // TODO: improve this
          if (res.text === IMPOSSIBLE_TRIP) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          if (res.text === NOT_SINGLE_REGION) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          if (res.text === NOT_FOUND_DISTANCE) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          if (res.text === NOT_FOUND_UNICODE) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          if (res.text === DIVISION_BY_ZERO) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          if (modelCode === BFR) {
            AnalyticsUtils.pushRouteError({ error: IMPOSSIBLE });
            dispatch(fetchDirectionsFailure());
            return;
          }

          dispatch(deleteErrorMessages());

          // polyline
          const path = MapUtils.constructPolyline(res.body.polyline_array);
          MapUtils.setPolyline(path);
          dispatch(updateDirectionsPolyline(path));

          const origin = [
            {
              type: 'origin',
              address: places[0].address,
              analytics: places[0].analytics,
            },
          ];
          const stopovers = res.body.stops || [];
          const chargeTime = res.body.total_charge_dur_s || 0;
          const destination = constructDestination({
            places,
            placesLen,
            res,
            chargeTime,
          });

          dispatch(updateDirectionsDistance(destination[0].distance));

          let chargers = [];
          let waypoints = [];
          const chargerPlaces =
            places.length > 2 ? places.slice(1, places.length - 1) : [];

          if (stopovers.length > 0) {
            chargers = stopovers.filter(charger => charger.trt_id);
            waypoints = stopovers.filter(
              waypoint => waypoint.type === 'stopover',
            );
          }

          let directions = origin;

          directions = directions.concat(stopovers);

          const flag = res.body.flag || null;
          if (flag === NO_SUPERCHARGER_FLAG) {
            dispatch(updateSuperchargersChargers(true));
          }

          if (chargers.length > 0) {
            dispatchRouteChargers({ getState, chargers, dispatch });
          } else {
            if (flag !== NO_SUPERCHARGER_FLAG) {
              dispatch(updateSuperchargersCharging(false));
            }

            AnalyticsUtils.pushRouteError({ error: NO_SUPERCHARGERS });
          }

          // push in analytics data for routing
          handleDirectionsAnalytics({
            origin,
            chargerPlaces,
            chargers,
            destination,
            chargeTime,
            waypoints,
            model,
          });

          directions = directions.concat(destination);

          dispatch(fetchDirectionsSuccess(directions));

          MapUtils.fitMapToPolyline();
        }
      });
    }
  };
}

export const DIRECTIONS_CLEAR_ALL = 'DIRECTIONS_CLEAR_ALL';
export const clearDirectionsAll = makeActionCreator(DIRECTIONS_CLEAR_ALL);

export const DIRECTIONS_TOGGLE_UI = 'DIRECTIONS_TOGGLE_UI';
export const toggleDirectionsUI = makeActionCreator(
  DIRECTIONS_TOGGLE_UI,
  'loaded',
  'requested',
);

export const DIRECTIONS_UPDATE_LABELS = 'DIRECTIONS_UPDATE_LABELS';
export const updateDirectionsLabels = makeActionCreator(
  DIRECTIONS_UPDATE_LABELS,
  'data',
);

export const DIRECTIONS_DELETE_ERROR = 'DIRECTIONS_DELETE_ERROR';
export const deleteDirectionsError = makeActionCreator(DIRECTIONS_DELETE_ERROR);

export const DIRECTIONS_BIND_DRAGGABLE = 'DIRECTIONS_BIND_DRAGGABLE';
export const bindDirectionsDraggable = makeActionCreator(
  DIRECTIONS_BIND_DRAGGABLE,
  'draggable',
);
